export const LocalStorageConstants = {
    SelectedBaseAssetSymbol: 'selected-base-asset-symbol',
    SelectedExpirationName: 'selected-expiration',
    SelectedOptionTypeName: 'selected-option-type',
    SelectedPortfolioGroupName: 'selected-portfolio-group-name',
    SelectedPortfolioName: 'selected-portfolio-name',
    SelectedStrikeName: 'selected-strike-name',
};
